import React, { lazy } from 'react';

const Records = lazy(() => import('./Records'));
const Rules = lazy(() => import('./Rules'));
const MonthlyReport = lazy(() => import('./MonthlyReport'));

const LeaveBalancePage = lazy(() => import('./LeaveBalancePage'));

export const attendancePageRoutes = [
  { path: '/attendance/records', component: Records },
  { path: '/attendance/leave-balances', component: LeaveBalancePage },
  { path: '/attendance/rules', component: Rules },
  { path: '/attendance/monthly-report', component: MonthlyReport }
];

export default attendancePageRoutes;
